module.exports = __webpack_public_path__ + "img/tv.a73d11b3.svg";